import React from "react";
// import { FaFacebook, FaTwitter, FaYoutube, FaInstagram, FaLinkedin } from "react-icons/fa";
// import { FooterContainer, FooterLink, FooterLinkItems, FooterLinksContainer, FooterLinksWrapper, FooterWrap, SocialLogo, SocialMedia, SocialMediaWrap, WebsiteRights } from "./FooterElements";
import { FooterContainer, FooterWrap, SocialMedia, SocialMediaWrap, WebsiteRights } from "./FooterElements";
// import { animateScroll as scroll } from "react-scroll";
// import Img from "../../images/logox.png"

const Footer = () => {
  // const toggleHome = () => {
  //   scroll.scrollToTop();
  // };

  return (
    <FooterContainer>
      <FooterWrap>
        {/* <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLink
                to="about"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={0}
              >Sobre nosotros</FooterLink>
              <FooterLink
                to="services"
                smooth={true}
                duration={500}
                spy={true}
                exact="true"
                offset={0}
              >Cómo funciona</FooterLink>
              <FooterLink to="/signin">Testimonios</FooterLink>
              <FooterLink to="/signin">Terminos y condiciones</FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLink to="/">Videos</FooterLink>
              <FooterLink to="/">Fundadores</FooterLink>
              <FooterLink to="/">Desarrollos</FooterLink>
              <FooterLink to="/">Servicios</FooterLink>
            </FooterLinkItems>
            <FooterLinkItems>
              <FooterLinkTitle>Social Media</FooterLinkTitle>
              <FooterLink to="/">Instagram</FooterLink>
              <FooterLink to="/">Facebook</FooterLink>
              <FooterLink to="/">Youtube</FooterLink>
              <FooterLink to="/">Twitter</FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer> */}
        <SocialMedia>
          <SocialMediaWrap>
            {/* <SocialLogo to="/" onClick={toggleHome} >
              <div style={{ backgroundColor: 'red', display: 'flex', padding: 0 }}>
                <ImageBg src={Img} alt="" />
              </div>
            </SocialLogo> */}
            <WebsiteRights>
              vanguardev © {new Date().getFullYear()} All rights reserved.
            </WebsiteRights>
            {/* <SocialIcons>
              <SocialIconLink href="/" target="_blank" aria-label="Facebook" />
              <FaFacebook />
              <SocialIconLink />
              <SocialIconLink href="/" target="_blank" aria-label="Instagram" />
              <FaInstagram />
              <SocialIconLink />
              <SocialIconLink href="/" target="_blank" aria-label="Youtube" />
              <FaYoutube />
              <SocialIconLink />
              <SocialIconLink href="/" target="_blank" aria-label="Twitter" />
              <FaTwitter />
              <SocialIconLink />
              <SocialIconLink href="/" target="_blank" aria-label="Linkedin" />
              <FaLinkedin />
              <SocialIconLink />
            </SocialIcons> */}
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
